var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_449_974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_449_974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 5L6.20001 23.6L24 20L23 5Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2 0L22.8 5.6L39.6 8.6L28.2 0Z",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8 39.6001C27.9333 33.2001 24.12 20.3601 23.8 19.4001L39.8 28.0001L29.8 39.6001Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 19.4001L10.4 38.8001L31.4 42.6001L23.8 19.4001Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20001 23.6001L23.8 19.4001L8.60001 41.6001L6.20001 23.6001Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 23.6L-0.8 21.8L-3 25L8.8 40.4001L6.2 23.6Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 2.19995L6.2 23.6L-3.2 21.2L-5 15.6L7.6 2.19995Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 5.60005L9.00001 1.60005L7.60001 0.800049L6.20001 23.6L22.8 5.60005Z",
    fill: "#5D5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2 4.88758e-05L22.8 5.60005L9.20001 1.80005V0.800049L10.2 -2.19995L28.2 4.88758e-05Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2 8.6001L22.8 5.6001L23.8 19.4001L41 13.4001L40.2 8.6001Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6 13L23.8 19.4L40 29.6L41.6 13Z",
    fill: "#A9A9A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPlaceholder);
export default __webpack_public_path__ + "static/media/account_placeholder.e312cd56e79771305d4c0e24bf16a21f.svg";
export { ForwardRef as ReactComponent };